import { render, staticRenderFns } from "./FAQ.vue?vue&type=template&id=d645300a&"
import script from "./FAQ.js?vue&type=script&lang=js&"
export * from "./FAQ.js?vue&type=script&lang=js&"
import style0 from "./FAQ.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports